import { render, staticRenderFns } from "./pieGroup1.vue?vue&type=template&id=3dc070ba&scoped=true&"
import script from "./pieGroup1.vue?vue&type=script&lang=js&"
export * from "./pieGroup1.vue?vue&type=script&lang=js&"
import style0 from "./pieGroup1.vue?vue&type=style&index=0&id=3dc070ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc070ba",
  null
  
)

export default component.exports